<script setup lang="ts">
import { TRPCClientError } from "@trpc/client";
import { useTRPC } from "~/plugins/trpcClient";
const $client = useTRPC();
const toast = useToast();

class RegisterView {
  avatarUrl: string = "";
  inviteToken: string = "";
  name: string = "";
  password: string = "";
  passwordConfirm: string = "";
  phone: string = "";

  $loading = false;

  async register() {
    this.$loading = true;

    console.log({
      phone: this.phone,
      password: this.password,
    });

    try {
      await $client.auth.register.mutate({
        avatarUrl: this.avatarUrl,
        inviteToken: this.inviteToken,
        name: this.name,
        password: this.password,
        passwordConfirm: this.passwordConfirm,
        phone: this.phone,
      });
    } catch (e) {
      if (e instanceof TRPCClientError) {
        console.log({
          data: e.data,
          message: e.message,
          meta: e.meta,
          shape: e.shape,
        });

        return toast.add({
          title: "Invalid data",
          description: e.data,
        });
      }
    }

    this.$loading = false;
  }
}

const view = reactive(new RegisterView());
</script>

<template>
  <form
    method="POST"
    action=""
    class="me-auto ms-auto mt-4 w-full max-w-md"
    @submit.prevent="view.register()"
  >
    <div class="text-center">
      <h2 class="font-heading text-3xl font-medium leading-normal">
        Welcome to Tairo
      </h2>
      <p
        class="font-alt text-sm font-normal leading-normal text-muted-400 mb-6"
      >
        Let's start by creating you account
      </p>
    </div>
    <div class="px-8 py-4">
      <div class="mb-4 space-y-4">
        <InputField
          v-model="view.name"
          label="Your Name"
          :input-props="{
            type: 'text',
            name: 'name',
            placeholder: 'ex: John Doe',
          }"
        />

        <InputField
          v-model="view.avatarUrl"
          label="Avatar URL"
          :input-props="{
            type: 'text',
            name: 'avatarUrl',
            placeholder: 'ex: https://example.com/avatar.png',
          }"
        />
      </div>
      <div class="mb-4 space-y-4">
        <InputField
          v-model="view.phone"
          label="Phone"
          :mask="['## #####-####']"
          :input-props="{
            type: 'phone',
            name: 'phone',
            placeholder: '00 00000-0000',
          }"
        />

        <InputField
          v-model="view.password"
          label="Password"
          :input-props="{
            type: 'password',
            name: 'password',
            placeholder: '••••••••••',
          }"
        />

        <InputField
          v-model="view.passwordConfirm"
          label="Confirm Password"
          :input-props="{
            type: 'password',
            name: 'passwordConfirm',
            placeholder: '••••••••••',
          }"
        />
      </div>
      <div class="mb-6"></div>
      <div class="mb-6">
        <UButton
          type="submit"
          :loading="view.$loading"
          label="Register"
          color="primary"
          block
          size="lg"
        />
      </div>

      <p
        class="text-muted-400 mt-4 flex justify-between font-sans text-sm leading-5"
      >
        <span>Already have an account?</span>
        <WLink to="/login">Login</WLink>
      </p>
    </div>
  </form>
</template>
